export default "__VITE_ASSET__BLA$Z5pu__"